import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNav = () => setIsOpen((open) => !open);
  const closeNav = () => setIsOpen(false);

  return (
    <header className="site-header">
      <div className="container header-content">
        <div className="logo">pavant.dev</div>
        <nav className="nav">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={toggleNav}
          >
            ☰
          </button>
          <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
            <li>
              <Link to="/" onClick={closeNav}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/projects" onClick={closeNav}>
                Projects
              </Link>
            </li>
            <li>
              <Link to="/projects#live-demo" onClick={closeNav}>
                Live Demo
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={closeNav}>
                Contact
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
